import { ActionTree, ActionContext } from 'vuex'
import { IAppState, IRootState } from '@/@types'
import CONSTANTS from '@/constants'
import { logError } from '@/helpers/bugsnag'

const actions: ActionTree<IAppState, IRootState> = {
  setIsPageLoading: (
    context: ActionContext<IAppState, IRootState>,
    isPageLoading: boolean
  ) => {
    context.commit('IS_PAGE_LOADING_UPDATED', isPageLoading)
  },
  setIsComponentLoading: (
    context: ActionContext<IAppState, IRootState>,
    isComponentLoading: boolean
  ) => {
    context.commit('IS_COMPONENT_LOADING_UPDATED', isComponentLoading)
  },
  setError: (context: ActionContext<IAppState, IRootState>, error: string) => {
    const firendlyError = CONSTANTS.FRIENDLY_ERRORS[error]
    const preparedError = firendlyError || error
    context.commit('APP_ERROR_UPDATED', preparedError)
    logError(preparedError)
    if (
      ['development', 'local'].includes(process.env.NODE_ENV || '') &&
      error !== ''
    ) {
      console.error(error)
    }
  },
  setNotification: (
    context: ActionContext<IAppState, IRootState>,
    notification: string
  ) => {
    context.commit('APP_NOTIFICATION_UPDATED', notification)
  },
  setWarning: (
    context: ActionContext<IAppState, IRootState>,
    warning: string
  ) => {
    context.commit('APP_WARNING_UPDATED', warning)
  },
  setSuccess: (
    context: ActionContext<IAppState, IRootState>,
    success: string
  ) => {
    context.commit('APP_SUCCESS_UPDATED', success)
  },
  setIsAppLoading: (
    context: ActionContext<IAppState, IRootState>,
    isAppLoading: boolean
  ) => {
    context.commit('IS_APP_LOADING_UPDATED', isAppLoading)
  },
  setOnboardingModalStatus: (
    context: ActionContext<IAppState, IRootState>,
    onboardingModalStatus: object
  ) => {
    context.commit('APP_ONBOARDING_MODAL_STATUS_UPDATED', onboardingModalStatus)
  },
  setVideoActive: (
    context: ActionContext<IAppState, IRootState>,
    videoActive: boolean
  ) => {
    context.commit('VIDEO_ACTIVE_UPDATED', videoActive)
  },
}

export default actions
